module.exports = {
  services: {
    api: {
      url: 'https://api.dev2.dappier.com',
      host: 'api.dev2.dappier.com',
      apiGatewayUrl: 'https://32zn1l9cqh.execute-api.us-east-1.amazonaws.com', // IGNORE THIS
    },
    env: 'dev2'
  },
  environment: 'Dev2',
  version: '0.0.0.0',
};
